module.exports = __webpack_public_path__ + "static/media/2008.ec565cdd.png";